<script lang="ts">
    import { Col, Pagination, PaginationItem, PaginationLink } from "sveltestrap";
    import Card from "../../Core/Card.svelte";
    import data from "../../../Data/BonusUi/BonusUi.json"
    import { href, Next, Previous } from "../../../utils/Constant/Constant";
</script>

<Col xl="12">
  <Card headerTitle="Pagination Color" cardHeaderprops="pb-0">
    <div slot="contentbody" class="pagination-color">
      {#each data.colorpaginationdata as paginationItem}
        <Pagination class="m-b-30" aria-label="Page navigation example">
          <ul class="pagination pagination-{paginationItem.color}">
            <PaginationItem>
              <PaginationLink {href}>{Previous}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink {href}>{'1'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink {href}>{'2'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink {href}>{'3'}</PaginationLink>
            </PaginationItem>
            <PaginationItem>
              <PaginationLink {href}>{Next}</PaginationLink>
            </PaginationItem>
          </ul>
        </Pagination>
      {/each}
    </div>
  </Card>
</Col>
